import { HttpStatusCode } from '@angular/common/http';

/**
 * Checks if the error is a 403 Forbidden with "Invalid token" message.
 * This typically indicates the user's session has expired or the token is invalid.
 *
 * @param error The error object from an HTTP response
 * @returns true if the error matches the criteria
 */
function isInvalidTokenError(error: any): boolean {
  return (
    error?.status === HttpStatusCode.Forbidden &&
    (typeof error?.error?.message === 'string' && error.error.message.includes('Invalid token'))
  );
}

/**
 * Checks if the error is an authentication error (401, 403, or invalid token).
 *
 * @param error The error object
 * @returns true if it is an auth error, false otherwise
 */
export function getAuthErrorMessage(error: any): boolean {
  return (
    error?.status === HttpStatusCode.Unauthorized || isInvalidTokenError(error)
  );
}
